import { DataLineChart } from "@/types/common";
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';

export interface BalanceReportType {
  labels: string[];
  values: number[];
}

export interface WithdrawRequest {
  coin: string;
  network?: string;
  address: string;
  amount: number;
}

export class BalanceService {
  private static readonly BALANCE_REPORT_ENDPOINT = '/app/wallet/report';
  private static readonly DEPOSIT_ADDRESS_ENDPOINT = '/app/wallet/deposit-address';
  private static readonly WITHDRAW_ENDPOINT = '/app/wallet/withdraw';

  public static async getBalanceReport(period: string): Promise<DataLineChart> {
    const res: AxiosResponse<DataLineChart> = await axiosInstance.get(BalanceService.BALANCE_REPORT_ENDPOINT, { params: { period } });
    return res.data;
  }

  public static async getDepositAddress(coin: string): Promise<string> {
    const res: AxiosResponse<string> = await axiosInstance.get(BalanceService.DEPOSIT_ADDRESS_ENDPOINT, { params: { coin } });
    return res.data;
  }

  public static async withdraw(data: WithdrawRequest): Promise<any> {
    const res: AxiosResponse<any> = await axiosInstance.post(BalanceService.WITHDRAW_ENDPOINT, data);
    return res.data;
  }
}
